import RequestForm from "@/pages/contact/RequestForm";
import { WORKSHOP_FORM } from "@/pages/contact/requestFormsContent";

export default function WorkshopRequest() {
  return <RequestForm spec={WORKSHOP_FORM} />;
}
